import { FeatureCollection } from 'geojson'
import { getH3Geojson } from 'map-style-utils'
import { useMemo } from 'react'
import { useSize } from '~map-preview/states/hexagons'
import { useNumericProperties } from '~map-preview/states/map'

export const useH3GeojsonData = (geojson?: FeatureCollection) => {
  const size: 'large' | 'medium' | 'small' = useSize()
  const properties = useNumericProperties()

  const { hexagonGeojson, resolution } = useMemo(() => {
    if (!geojson) return { hexagonGeojson: undefined, resolution: undefined }

    const { hexagonGeojson, resolution } = getH3Geojson(geojson, {
      size,
      aggregateProperties: properties.map((item) => item.name), // aggregateProperties,
      aggregateType: 'SUM' // Currently doesn't do anything but will be integrated somewhere in the future
    })

    return { hexagonGeojson, resolution }
  }, [geojson, size, properties])

  return { hexagonGeojson, resolution }
}
